// extracted by mini-css-extract-plugin
export default {"wrapper":"MezzaLogFilterBlock_wrapper__uagoK"};